<template>
  <div class="using-help">
    <van-collapse v-model="activeNames">
      <van-collapse-item
        :title="item.q"
        :name="i"
        v-for="(item, i) in questionsList"
        :key="i"
      >
        <div v-html="item.a"></div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { getUseHelp } from "@/utils/api/user";
export default {
  data() {
    return {
      activeNames: [],
      questionsList: []
    };
  },
  mounted() {
    getUseHelp().then((res) => {
      if (res.success) {
        this.questionsList = res.data.map((e) => {
          return {
            q: e.title,
            a: e.contents
          };
        });
      }
    });
  }
};
</script>

<style lang="scss">
.using-help {
  padding: 10px 20px;
  .van-cell__title {
    text-align: left;
    font-weight: 700;
  }
  .van-collapse-item__content {
    p,
    div {
      text-align: justify;
      line-height: 28px;
      font-size: 12px;
      color: #333;
    }
  }
}
</style>
